export default __webpack_public_path__ + "static/MelanieNielson-a217073c6ba1b659596d455b9dd7239a.jpg";